import React, { Component, Fragment } from "react";
import { Cookies } from "react-cookie";
import { Button, Form, Input, message } from "antd";
import { NumberOutlined, MobileOutlined } from "@ant-design/icons";
import { Constants } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import Rules from "../scripts/rules";

class LoginPage extends Component {
  constructor() {
    super();

    this.state = {
      step: 1,
    };

    this.cookies = new Cookies();
  }
  handleLogin = (values) => {
    this.setState({ submitting: true });

    API.user
      .login(values)
      .then((result) => {
        if (result.status === 1) {
          message.success(result.message);
          this.setState({ phone: values.phone, step: 2, submitting: false });
        } else {
          message.error(result.message);
          this.setState({ submitting: false });
        }
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };

  handleVerify = (values) => {
    this.setState({ submitting: true });

    API.user
      .verify(values)
      .then((result) => {
        if (result.access_token) {
          const date = new Date();
          date.setTime(date.getTime() + Constants.expires_in);
          this.cookies.set("AccessToken", result.access_token, {
            path: "/",
            expires: date,
            domain: window.location.hostname,
          });
          window.location = "/";
        } else {
          message.error(result.message);
          this.setState({ submitting: false });
        }
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };
  render() {
    const { phone, step, submitting } = this.state;

    return (
      <Fragment>
        <img
          src="/images/logo-big.png"
          alt="damavand Market"
          width={200}
          height={200}
        />
        <h1>{Resources.login}</h1>
        {step === 1 && (
          <Form initialValues={{ phone: phone }} onFinish={this.handleLogin}>
            <Form.Item name="phone" rules={Rules.mobile}>
              <Input
                type="text"
                size="large"
                dir="ltr"
                suffix={<MobileOutlined />}
                onPressEnter={this.handleLogin}
                placeholder={Resources.enterMobile}
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                loading={submitting}
                block
              >
                {Resources.sendCode}
              </Button>
            </Form.Item>
          </Form>
        )}
        {step === 2 && (
          <Form initialValues={{ phone: phone }} onFinish={this.handleVerify}>
            <Form.Item name="token" rules={Rules.required}>
              <Input
                type="text"
                size="large"
                dir="ltr"
                suffix={<NumberOutlined />}
                onPressEnter={this.handleVerify}
                placeholder={Resources.enterCode}
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                loading={submitting}
                block
              >
                {Resources.enter}
              </Button>
            </Form.Item>
          </Form>
        )}
      </Fragment>
    );
  }
}

export default LoginPage;
